export const DEVICE_ACCESS_EVENT = 'zeroth:device-access';
export type DeviceAccessFailure = 'DEVICE_LIMIT_EXCEEDED' | 'DEVICE_VERIFICATION_UNAVAILABLE' | 'UNAUTHORIZED';

export function apiErrorCode(error: unknown): string | undefined {
  return (error as { response?: { data?: { error?: { code?: string } } } } | null)?.response?.data?.error?.code;
}

export function notifyDeviceAccessFailure(code: string | undefined): void {
  if (code === 'DEVICE_LIMIT_EXCEEDED' || code === 'DEVICE_VERIFICATION_UNAVAILABLE' || code === 'UNAUTHORIZED') {
    window.dispatchEvent(new CustomEvent<DeviceAccessFailure>(DEVICE_ACCESS_EVENT, { detail: code }));
  }
}
